module.exports = __webpack_public_path__ + "img/ski_place9.07576447.png";